import { FC } from 'react';

export const PendingInviteSvg: FC = () => (
  <svg
    width="300"
    height="300"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_502_7252"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="300"
      height="300"
    >
      <rect width="300" height="300" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_502_7252)">
      <path
        d="M66.3346 181.825V244.505L17.4346 216.315L17.4646 153.615L66.3346 181.825Z"
        fill="#C7C8DD"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M115.245 147.365L115.205 153.595L66.335 181.825L66.355 175.555L115.245 147.365Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M115.245 216.315L66.3445 244.505V181.825L115.205 153.595L115.245 216.305V216.315Z"
        fill="#F7F8FC"
        stroke="#C7C8E0"
        stroke-linejoin="round"
      />
      <path
        d="M17.4346 147.345L17.4646 153.615L66.3346 181.825L66.3546 175.555L17.4346 147.345Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M66.3643 119.105L115.244 147.365L109.774 150.525L66.3643 125.345V119.105Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M17.4346 147.345L66.3246 119.135V125.375L22.8146 150.525L17.4346 147.345Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M114.505 147.765L66.1046 119.345L17.5646 147.495L66.3546 175.555L114.505 147.755V147.765Z"
        fill="#F7F8FC"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M66.3649 119.105L66.2949 106.575L126.115 141.045L126.065 222.545L115.245 216.305V147.355L66.3649 119.095V119.105Z"
        fill="#C7C8DD"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M66.3249 100.295L66.2949 106.575L126.115 141.045V134.775L66.3249 100.295Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M185.794 106.595L126.114 141.045V134.775L185.764 100.295L185.794 106.595Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M126.065 222.555L185.795 188.085V106.595L126.115 141.045L126.065 222.555Z"
        fill="#F7F8FC"
        stroke="#C7C8E0"
        stroke-linejoin="round"
      />
      <path
        d="M185.765 100.295L126.045 65.8252L126.115 72.1252L180.335 103.445L185.765 100.305V100.295Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M66.3242 100.295L126.044 65.855L126.114 72.125L71.7642 103.425L66.3242 100.295Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M126.115 134.775L66.6346 100.475L126.045 65.8552L185.265 100.405L126.115 134.765V134.775Z"
        fill="#F7F8FC"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M185.795 106.605L223.845 84.635L223.805 90.885L185.765 112.875L185.795 106.595V106.605Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M185.795 175.875L223.845 153.615C223.835 132.705 223.815 111.795 223.805 90.885C211.125 98.215 198.445 105.545 185.765 112.875L185.795 175.865V175.875Z"
        fill="#F7F8FC"
        stroke="#C7C8E0"
        stroke-linejoin="round"
      />
      <path
        d="M174.935 56.4951L223.845 84.6951L218.415 87.8351L174.945 62.7551V56.4951H174.935Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M142.295 75.2151L174.955 56.4951V62.6951L147.785 78.3851L142.305 75.2151H142.295Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M223.845 84.6551L174.915 56.4951L142.335 75.1551L185.765 100.295L185.795 106.595L223.845 84.6451V84.6551Z"
        fill="#F7F8FC"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M126.114 134.775L155.924 91.2354L185.764 100.295L126.114 134.775Z"
        fill="#F7F8FC"
        stroke="#C7C8E0"
        stroke-linejoin="round"
      />
      <path
        d="M115.114 128.435L126.104 134.775L155.914 91.2351L185.754 100.295L174.924 94.0451L145.064 85.2451L115.114 128.445V128.435Z"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M155.924 91.2351L145.064 85.2451L115.114 128.445L126.104 134.785L155.914 91.2451L155.924 91.2351Z"
        fill="white"
        stroke="#C7C8E0"
        stroke-linejoin="round"
      />
      <path
        d="M185.765 100.295L155.925 91.2351L145.065 85.2451L174.925 94.0451L185.755 100.295H185.765Z"
        fill="white"
        stroke="#C7C8E0"
        stroke-linejoin="round"
      />
      <path
        d="M216.195 101.935V126.995L205.315 133.265V108.175L216.195 101.935Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M199.865 111.315L199.885 136.405L189.045 142.645L189.005 117.595L199.865 111.315Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M199.865 142.665L199.885 161.465L189.005 167.735V148.925L199.865 142.665Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M205.295 139.535V158.335L216.185 152.045V133.275L205.295 139.535Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M77.1543 181.825L77.2043 206.915L88.0743 200.635L88.0143 175.545L77.1543 181.825Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M93.5145 172.445L93.4745 197.525L104.315 191.235L104.335 166.165L93.5145 172.445Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M93.4941 203.785V222.595L104.344 216.305V197.495L93.4941 203.795V203.785Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M88.0748 206.885L77.2148 213.195V231.965L88.0748 225.695V206.885Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M180.395 116.005L169.505 122.245L169.575 147.365L180.395 141.085V116.005Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M131.494 144.195V169.285L142.384 162.995L142.324 137.905L131.504 144.185L131.494 144.195Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M147.765 134.815L164.075 125.385V150.485L147.795 159.885L147.775 134.825L147.765 134.815Z"
        fill="white"
        stroke="#C7C8DD"
        stroke-linejoin="round"
      />
      <path
        d="M147.785 185.145L147.755 210.685L164.065 201.135L164.025 175.565L147.785 185.155V185.145Z"
        fill="#27245C"
      />
      <path
        d="M169.534 197.505L169.484 166.135L142.354 181.825L142.324 213.175L147.764 210.005L147.794 184.965L164.034 175.565L164.074 200.645L169.534 197.515V197.505Z"
        stroke="#27245C"
        stroke-miterlimit="10"
      />
      <path
        d="M265.136 201.505C278.083 189.917 276.781 167.343 262.228 151.084C247.675 134.824 225.383 131.037 212.436 142.625C199.49 154.213 200.792 176.787 215.345 193.046C229.897 209.306 252.19 213.093 265.136 201.505Z"
        fill="#27245C"
      />
      <path
        d="M212.502 195.591C219.83 203.777 228.907 209.144 238 211.396C249.156 214.159 260.334 212.233 268.332 205.075C282.848 192.082 281.388 166.77 265.07 148.54C257.32 139.881 247.613 134.377 238 132.376"
        stroke="#24275B"
      />
      <path
        d="M220.295 167.655L255.295 181.805"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M237.295 191.315V157.315"
        stroke="white"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M172.259 214.038C172.239 213.762 172.445 213.522 172.72 213.502L177.208 213.165C177.483 213.144 177.723 213.351 177.744 213.626C177.765 213.902 177.558 214.142 177.283 214.162L173.294 214.461L173.593 218.45C173.614 218.726 173.407 218.966 173.132 218.986C172.857 219.007 172.617 218.8 172.596 218.525L172.259 214.038ZM173.084 213.621C180.222 219.763 186.347 223.728 192.823 226.519C199.303 229.312 206.157 230.939 214.771 232.379L214.606 233.366C205.96 231.92 199.015 230.277 192.427 227.438C185.836 224.597 179.626 220.569 172.432 214.379L173.084 213.621Z"
        fill="#252858"
      />
      <path
        d="M58.3584 72.041L65.3054 90.8857"
        stroke="#252858"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M24.7319 79.4976L61.992 98.2833"
        stroke="#252858"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
    </g>
  </svg>
);
